"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzIcon = _interopRequireDefault(require("./../OzIcon/OzIcon.js"));

var _OzCard = _interopRequireDefault(require("./../OzCard/OzCard.js"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzTooltip__Wrapper",
  componentId: "sc-rkpua1-0"
})(["\n  position: relative;\n  display: inline-block;\n  cursor: help;\n  height: 1px;\n  overflow: visible;\n  width: 16px;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n\n  &:hover > *{\n    display: block !important;\n  }\n"]);

var Cta = _styledComponents.default.div.withConfig({
  displayName: "OzTooltip__Cta",
  componentId: "sc-rkpua1-1"
})(["\n  position: absolute;\n  top: -11px;\n  right: 0px;\n"]);

var Tip = _styledComponents.default.div.withConfig({
  displayName: "OzTooltip__Tip",
  componentId: "sc-rkpua1-2"
})(["\n  display: none;\n  position: absolute;\n  top: -13px;\n  left: -2px;\n  min-width: 200px;\n  text-align: center;\n  z-index: 999;\n"]);

var Icon = _styledComponents.default.div.withConfig({
  displayName: "OzTooltip__Icon",
  componentId: "sc-rkpua1-3"
})(["\n  position: absolute;\n  top: 2px;\n  left: 2px;\n"]);

var OzTooltip = function OzTooltip(_ref) {
  var link = _ref.link,
      children = _ref.children;
  return __jsx(Wrapper, null, __jsx(Cta, null, __jsx(_OzIcon.default, {
    name: "alert",
    size: "16px"
  })), __jsx(Tip, null, __jsx(Icon, null, __jsx(_OzIcon.default, {
    name: "alert",
    size: "16px",
    color: _consts.CHETWODEBLUE
  })), __jsx(_OzCard.default, null, children)));
};

var _default = OzTooltip;
exports.default = _default;